import { enableProdMode } from "@angular/core"
import { register } from "swiper/element/bundle"
import { bootstrapApplication } from "@angular/platform-browser"

import { AppComponent } from "./app/app.component"
import { appConfig } from "./app/app.config"
import { environment } from "./environments/environment"

if (environment.production) {
    enableProdMode()
}

// Swipe registrieren
register()


bootstrapApplication(AppComponent, appConfig)
    .catch(err => console.log(err))

